var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8ffe8;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.6,479.2H32.8V16.4C32.8,7.3,25.4,0,16.4,0S0,7.3,0,16.4v479.2c0,9.1,7.3,16.4,16.4,16.4h479.2c9.1,0,16.4-7.3,16.4-16.4s-7.3-16.4-16.4-16.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.1,459.7h95.4c9.1,0,16.4-7.3,16.4-16.4V140.9c0-9.1-7.3-16.4-16.4-16.4h-95.4c-9.1,0-16.4,7.3-16.4,16.4v302.4c0,9.1,7.3,16.4,16.4,16.4h0ZM91.5,157.3h62.6v269.6h-62.6V157.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.9,459.7h95.4c9.1,0,16.4-7.3,16.4-16.4V29.1c0-9.1-7.3-16.4-16.4-16.4h-95.4c-9.1,0-16.4,7.3-16.4,16.4v414.2c0,9.1,7.3,16.4,16.4,16.4ZM248.3,45.5h62.6v381.4h-62.6V45.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.7,459.7h95.4c9.1,0,16.4-7.3,16.4-16.4v-229.8c0-9.1-7.3-16.4-16.4-16.4h-95.4c-9.1,0-16.4,7.3-16.4,16.4v229.8c0,9.1,7.3,16.4,16.4,16.4ZM405,229.9h62.6v197h-62.6v-197Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart1);
export default __webpack_public_path__ + "static/media/chart-1.f9a47eceb5ebb993699a0c4189d5f60d.svg";
export { ForwardRef as ReactComponent };